import client from "./axios";

const baseUrl = "https://internal-api.getmoveapp.com/api/v1/base";
//const baseUrl = "http://localhost:3000/api/v1/base";

export type MassiveNotificationTarget = "circle" | "all";

export const Notifications = {
  sendMassive: (body: {
    title: string;
    message: string;
    target: MassiveNotificationTarget;
  }) => client.post(`${baseUrl}/send-massive-notifications`, body),
  sendToUser: (body: { userId: string; title: string; message: string }) =>
    client.post(`${baseUrl}/send-user-notification`, body),
};
